// @flow

import * as React from 'react';

import { ResponsiveImage } from '@ta/media.image';
import { Icon } from '@ta/styleguide.icon';
import TripAvatars from '@ta/trips.trip-avatars';
import { InteractionLogger, ItemIdContext } from '@ta/tracking.interactions';

import LinkToTrip from './LinkToTrip';
import UGCShelfItemInfo from './UGCShelfItemInfo';
import styles from './ShelfTripSection.less';

type Props = {
  /** The json trip object */
  trip: any,
};

const tripLinkTo = (trip: any) => ({
  page: 'Trips',
  tripId: trip?.id,
  tripTitle: trip?.status === 'PUBLIC' ? trip?.title : undefined,
});

const getPhoto = (trip: any) => {
  const sources = trip?.photo?.photoSizes;
  const height = 150;
  const width = '100%';
  if (!sources) {
    return (
      <div className={styles.placeholder} style={{ width, height }}>
        <Icon name="suitcase" />
      </div>
    );
  }

  return <ResponsiveImage sources={sources} width={width} height={`${height}px`} />;
};

const ShelfTripSection = ({ trip }: Props) => {
  const avatar = <TripAvatars trip={trip} avatarSize="default" />;
  const itemId = { itemId: trip?.id };

  return (
    <ItemIdContext.Provider value={itemId}>
      <div className={`ui_card ${styles.trip_section}`}>
        <div className={styles.trip_photo_container}>
          <LinkToTrip trip={trip}>{getPhoto(trip)}</LinkToTrip>
          <div className={styles.avatar}>{avatar}</div>
        </div>
        <div className={styles.trip_details_container}>
          <LinkToTrip trip={trip}>
            <div className={styles.trip_title_container}>{trip?.title}</div>
          </LinkToTrip>
          <InteractionLogger>
            {logFeedClick => (
              <UGCShelfItemInfo
                trip={trip}
                member={trip?.owner}
                locations={trip?.orderedLocations}
                taggedPoisLinkTo={tripLinkTo(trip)}
                onClick={e => {
                  logFeedClick(e, 'feedClick');
                }}
              />
            )}
          </InteractionLogger>
        </div>
      </div>
    </ItemIdContext.Provider>
  );
};

export default ShelfTripSection;
